import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "container",
    staticClass: "v-btn-expand",
    class: _vm.classes,
    style: _vm.styles
  }, [_c('div', {
    ref: "activator",
    staticClass: "v-btn-expand__activator"
  }, [_vm._t("activator", null, {
    "attrs": {
      'aria-expanded': _vm.isOpen.toString(),
      'aria-controls': _vm.contentId
    }
  })], 2), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "v-btn-expand__content",
    attrs: {
      "id": _vm.contentId,
      "aria-hidden": (!_vm.isOpen).toString()
    }
  }, [_c('div', {
    staticClass: "v-btn-expand__content__inner"
  }, [_vm.isOpen ? _vm._t("default") : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "v-btn-expand__close-btn"
  }, [_c('ProfileCloseBtn', {
    attrs: {
      "aria-controls": _vm.contentId,
      "aria-expanded": _vm.isOpen.toString()
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  })], 1)])]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-1436135a_0", {
    source: ".shake{animation:shake .82s cubic-bezier(.36,.07,.19,.97) both}@keyframes shake{10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(2px,0,0)}30%,50%,70%{transform:translate3d(-4px,0,0)}40%,60%{transform:translate3d(4px,0,0)}}",
    map: undefined,
    media: undefined
  }), inject("data-v-1436135a_1", {
    source: ".v-btn-expand[data-v-1436135a]{--c-container-transition-speed:500ms;--arrow-size:0.75rem;position:relative;transition:height var(--c-container-transition-speed)}.v-btn-expand__content[data-v-1436135a]{height:calc(100% - var(--c-btn-height));left:0;position:absolute;pointer-events:none;visibility:hidden;transition:transform var(--c-container-transition-speed),visibility var(--c-container-transition-speed);transform:translateY(calc(var(--arrow-size) + var(--p-btn-box-shadow-size)));width:100%}.v-btn-expand__content__inner[data-v-1436135a]{background:var(--c-bg-color);border:var(--c-border-width) solid var(--c-border-color);border-width:min(var(--c-border-width),5px);border-radius:var(--p-btn-border-radius);border-radius:min(var(--p-btn-border-radius),10px);box-shadow:var(--p-btn-box-shadow);height:calc(100% - var(--c-btn-height))}.v-btn-expand__content__inner[data-v-1436135a]:after{content:\"\";border:var(--arrow-size) solid var(--c-border-color);border-top-width:0;border-top-color:transparent;border-left-color:transparent;border-right-color:transparent;left:50%;position:absolute;top:calc(-1 * var(--arrow-size));transform:translateX(-50%);transition:border var(--c-container-transition-speed);height:0}.v-btn-expand__close-btn[data-v-1436135a]{margin-top:calc(.75rem + var(--p-btn-box-shadow-size));text-align:center}.v-btn-expand--is-open .v-btn-expand__content[data-v-1436135a]{height:unset;pointer-events:unset;visibility:visible}.v-btn-expand--is-open[data-v-1436135a]  .site-btn .site-btn__down,.v-btn-expand--is-open[data-v-1436135a]  .site-btn .site-btn__img{opacity:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-1436135a";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var BtnExpand = __vue_component__;
export { BtnExpand as default };